<template>
  <div class="company-page" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="filter" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="6">
            <el-form-item :label="$t('manage.company')">
              <el-input v-model="filter.company_name" :placeholder="$t('manage.keywords')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="search-btn-box">
              <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h20"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="company_id" label="ID" width="100"> </el-table-column>
        <el-table-column prop="company_name" :label="$t('manage.company')"> </el-table-column>
        <el-table-column :label="$t('manage.company_logo')">
          <template slot-scope="scope">
            <div v-if="scope.row.logo" class="list-pic"><img :src="scope.row.logo" class="img" /></div>
            <div v-else class="list-pic-none">None</div>
          </template>
        </el-table-column>
        <el-table-column prop="title" :label="$t('manage.title')"></el-table-column>
        <el-table-column prop="province_name" :label="$t('manage.province')" width="200"></el-table-column>
        <el-table-column prop="city_name" :label="$t('manage.city')" width="200"></el-table-column>
        <el-table-column prop="district_name" :label="$t('manage.area')" width="200"></el-table-column>
        <el-table-column prop="created_at" :label="$t('screen.add_time')"></el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.company_id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog750"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        :rules="editOneRule"
        ref="dialogRef"
      >
        <div class="form-info">
          <el-form-item :label="$t('manage.company')" prop="company_name">
            <el-input v-model="editOne.company_name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('manage.company_logo')" class="upload-box">
            <el-upload
              ref="upload"
              name="file"
              :action="uploadAction()"
              :limit="1"
              :file-list="fileList"
              list-type="picture"
              :headers="{'Authorization': token}"
              :data="{'type': 1}"
              :on-remove="handleRemove"
              :beforeUpload="beforeFilesUpload"
              :on-success="handleFilesSuccess"
            >
              <el-button size="small" type="primary">{{$t('manage.upload')}}</el-button>
              <div slot="tip" class="el-upload__tip">{{$t('manage.pic_tip')}}</div>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('manage.title')" prop="title">
            <el-input v-model="editOne.title"></el-input>
          </el-form-item>
          <div class="address-box">
            <el-row>
              <el-form-item :label="$t('manage.province')" prop="province_id">
                <el-select v-model="editOne.province_id" :placeholder="$t('manage.province')" @change="getCity" style="width: 120px" size="small">
                  <el-option
                    v-for="(item,index) of addressObj.provinceArr"
                    :key="index"
                    :label="item.area_name"
                    :value="item.area_id"
                    ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item :label="$t('manage.city')" prop="city_id">
                <el-select v-model="editOne.city_id" :placeholder="$t('manage.city')" @change="getArea" style="width: 120px" size="small">
                  <el-option
                    v-for="(item,index) of addressObj.cityArr"
                    :key="index"
                    :label="item.area_name"
                    :value="item.area_id"
                    ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('manage.area')" prop="district_id">
                  <el-select v-model="editOne.district_id" :placeholder="$t('manage.area')" style="width: 120px" size="small">
                    <el-option
                      v-for="(item,index) of addressObj.areaArr"
                      :key="index"
                      :label="item.area_name"
                      :value="item.area_id"
                    ></el-option>
                  </el-select>
              </el-form-item>
            </el-row>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import companyApi from "@/api/system/company";
import publicApi from "@/api/system/public";
import commonJs from '@/utils/common'
import { getToken } from '@/utils/auth'
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      pageInfo: {
        sortBy: 'company_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 20
      },
      filter: {
        company_name: ''
      },
      cnt_all: 0,
      editOneRule: {
        company_name: [{ required: true, message: this.$t('manage.please_company'), trigger: "blur" }],
        title: [{ required: true, message: this.$t('manage.title'), trigger: "blur" }]
      },
      editType: -1,
      editOne: {
        company_id: '',
        company_name: '',
        logo: '',
        title: '',
        province_id: '',
        city_id: '',
        district_id: ''
      },
      addressObj: {
        provinceArr: [],
        cityArr: [],
        areaArr: []
      },
      token: getToken(),
      fileList: []
    };
  },
  async created() {
    await this.getProvince()
    this.getTableData(this.pageInfo.page)
  },
  methods: {
    // 获取省份列表
    async getProvince() {
      await publicApi.getProvinceList().then((res) => {
        if (res.data.code === 1000) {
          this.addressObj.provinceArr = res.data.data
          this.editOne.province_id =''
          if(this.addressObj.provinceArr.length){
            this.getCity(this.addressObj.provinceArr[0].area_id, '', '')
          }
        }
      })
    },
    // 获取城市列表
    async getCity(province_id, city_id, district_id) {
      await publicApi.getCityList({
        province: province_id
      }).then((res) => {
        if (res.data.code === 1000) {
          this.addressObj.cityArr = res.data.data
          let g_city_id = this.addressObj.cityArr[0].area_id
          if(city_id){
            this.editOne.city_id = city_id
            g_city_id = city_id
          }else{
            this.editOne.city_id = ''
          }
          if(this.addressObj.cityArr.length){
            this.getArea(g_city_id, district_id)
          }
        }
      })
    },
    // 获取区域列表
    getArea(city_id, district_id) {
      publicApi.getAreaList({
          city: city_id
        }).then((res) => {
        if (res.data.code === 1000) {
          this.addressObj.areaArr = res.data.data
          if(district_id){
            this.editOne.district_id = district_id
          }else{
            this.editOne.district_id = ''
          }
        }
      })
    },
    // 获取列表
    getTableData(pageIndex) {
      this.loading = true;
      this.pageInfo.filter = ''
      this.pageInfo.page = pageIndex;
      let filter = this.filter;
      filter = filter && commonJs.obj.removeNullKey(filter);
      if (filter && Object.keys(filter).length) {
        this.pageInfo.filter = JSON.stringify(filter);
      }
      companyApi.getCompany(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    async openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          company_id: '',
          company_name: '',
          logo: '',
          title: '',
          province_id: '',
          city_id: '',
          district_id: ''
        };
        this.fileList= []
        this.editType = "create";
      } else {
        if(index.province_id){
          await this.getCity(index.province_id, index.city_id, index.district_id)
        }
        this.editOne = {
          company_id: index.company_id,
          company_name: index.company_name,
          logo: index.logo,
          title: index.title,
          province_id: index.province_id,
          city_id: index.city_id,
          district_id: index.district_id
        }
        if(index.logo){
          this.fileList[0] = {
            name: index.company_name,
            url: index.logo
          }
        }else{
          this.fileList= []
        }
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          companyApi.companyEdit(this.editOne.company_id, this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.mod_success'));
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
      
    },
    createItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          companyApi.companyAdd(this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.add_success'));
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
      
    },
    delItem(id) {
      this.$confirm(this.$t('manage.del_tip'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          companyApi.companyDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    },
    uploadAction() {
      return process.env.VUE_APP_BASE_API+'/api/system/uploadFile';
    },
    handleRemove() {
      this.fileList = []
      this.editOne.logo = ''
    },
    beforeFilesUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "png";
      if (!extension) {
        this.$message({
          message: this.$t('manage.png_tip'),
          type: "error",
        });
      }
      return extension;
    },
    handleFilesSuccess(res, file) {
      if (res.data.code === 1000) {
        this.$message.success(this.$t("control.upload_success"));
        this.editOne.logo = res.data.data.file_url;
        this.fileList[0]=res.data.data.file_url;
      } else {
        this.$message.error(this.$t("control.error") + res.data.message);
      }
    },
    
  }
};
</script>
<style lang='less'>
.company-page {
  width: 100%;
  .form-info{
    padding-left: 8px;
    .el-form-item__label{
      width:85px;
    }
  }
}
</style>